<template>
  <div class="page border-box" :class="loginShow==1?'overflow':''" v-wechat-title="$route.meta.title">
    <div class="banner">
      <img class="study_bg" src="../../assets/study_bg.png" alt="">
      <img class="study_logo" v-lazy="certificateInfo.logo" alt="">
    </div>

    <div class="study_con border-box">
      <div class="study_li card border-box" v-if="certificateInfo.certificate">
        <img class="study_card" v-lazy="certificateInfo.certificate" alt="">
        <div class="card_btn">
          <img src="../../assets/study_btn1.png" alt="" @click="resetFunBtn()" v-show="certificateInfo.is_reset==1">
          <img src="../../assets/study_btn2.png" alt=""  @click="shareCardShow=1">
        </div>
      </div>
      <div class="study_li border-box" :class="item.state==1?'complete':''" :data-id="item.id" :data-iscomplete="item.state" :data-score="item.score" @click="toDetail($event)"  v-for="(item,index) in shopsInfo">
        <div class="study_img">
          <img class="img" v-lazy="item.logo" alt="">
          <div class="score" v-if="item.state==1">
            <span>
              <img src="../../assets/study_border.png" alt="">
              完成研学<br>{{item.score}}分
            </span>
          </div>
        </div>
        <div class="study_name box">
          <div class="flex name border-box hide">{{item.name}}</div>
          <div class="study_btn" v-if="item.state==1">研学完成</div>
          <div class="study_btn" v-if="item.state==0" :data-id="item.id" @click.stop="isToDetail($event)">研学打卡</div>
          <!--<div class="study_btn" v-if="item.state==0" @click="loginShow=1">研学打卡</div>-->
        </div>
      </div>
    </div>

    <div class="bottom_tab box">
      <div class="flex tc" @click="ruleShow=1">活动规则</div>
      <div class="flex tc" @click="shareCardShow=1">我的证书</div>
      <div class="flex tc" @click="listShowFun(pageAlert)">研学排行</div>
    </div>

    <!--证书分享弹窗-->
    <div class="alert_certificate" :class="shareCardShow==0?'none':'curr'">
      <span class="mask" @click="shareCardShow=0"></span>
      <div class="alert_certificate_box border-box">
        <img class="close certificate_close" src="../../assets/icon_05.png" alt="" @click="shareCardShow=0">
        <div v-if="certificateInfo.certificate">
          <div class="certificate_tit tc border-box hide">{{userInfo.name}}的研学结业证书</div>
          <img class="alert_certificate_img" v-lazy="certificateInfo.certificate" alt="">
          <div class="alert_certificate_tip tc">长按图片保存相册或发送给朋友</div>
        </div>
        <div :class="certificateInfo.certificate?'none':''" style="color: #333;font:bold .32rem 'Microsoft YaHei';padding: .4rem 0;text-align: center;">
          暂无证书
        </div>
      </div>
    </div>

    <!--研学结业证书排行弹窗-->
    <div class="alert_list" :class="listShow==0?'none':''">
      <span class="mask" @click="listClose"></span>
      <div class="list_box">
        <img class="close list_close" src="../../assets/icon_05.png" alt="" @click="listClose">
        <div class="list_top border-box hide">研学结业证书排行</div>
        <div class="list_tab">
          <span :class="listType==0?'curr':''" data-type="0" @click="certificateListSel($event)" >最新</span>
          <span :class="listType==1?'curr':''" data-type="1" @click="certificateListSel($event)">得分</span>
        </div>
        <div class="list_ul_box" id="scollBox">
          <div class="list_ul clearfix">
            <div class="list_li border-box" v-for="(item,index) in certificateListData">
              <img class="list_li_img img"  v-lazy="item.certificate" alt="" @click="seeImg(0,item.certificate)">
              <div class="list_li_info box">
                <div class="flex list_tit hide">{{item.name}}</div>
                <div class="flex list_score">{{item.score}}分</div>
              </div>
            </div>
          </div>
          <p class="load-tip load-tip1" id="loadTip" style="height: auto;color:#999;">{{loadText1}}</p>
        </div>

      </div>
    </div>

    <!--注册弹窗-->
    <div class="alert_login" :class="loginShow==0?'none':'curr'">
      <span class="mask" @click="loginShow=0"></span>
      <div class="login_box border-box">
        <img class="close login_close" src="../../assets/icon_05.png" alt="" @click="loginShow=0">
        <div class="login_tit hide tl">为了更好的为您服务，请先绑定您的个人信息</div>
        <div class="login_li border-box" style="margin-top: .33rem;">
          <img class="login_li_icon" src="../../assets/icon_20_study.png" alt="">
          <input class="border-box" v-model="studyName" type="text" placeholder="姓名">
        </div>
        <div class="login_li border-box">
          <img class="login_li_icon" src="../../assets/icon_21_study.png" alt="">
          <input class="border-box" v-model="studyTel" type="number" placeholder="手机号">
        </div>
        <div class="login_li border-box" style="background: #fff;">
          <div class="box border-box">
            <div class="flex">
              <img class="login_li_icon" src="../../assets/icon_22_study.png" alt="">
              <input class="border-box" type="text" v-model="studyYzm" placeholder="验证码">
            </div>
            <div class="flex yzm_btn tc" :class="yzmSend==1?'disabled':''" @click="getYzm">{{yzmTxt}}</div>
          </div>
        </div>
        <button class="login_btn tc" @click="loginSubmit"  v-show="showBtn==1">确&nbsp;&nbsp;定</button>
      </div>
    </div>

    <!--活动规则弹窗-->
    <div class="alert_rule" :class="ruleShow==0?'none':''">
      <span class="mask" @click="ruleShow=0"></span>
      <div class="rule_box border-box">
        <img class="close login_close" src="../../assets/icon_05.png" alt="" @click="ruleShow=0">
        <div class="rule_tit">活动规则</div>
        <div class="article" style="padding: 0!important;">
          <div  v-html="certificateInfo.content"></div>
        </div>
      </div>
    </div>



    <p class="load-tip" ref="loadtip">{{loadText}}</p>
  </div>


</template>

<script>
  import axios from 'axios'
  import {getServer} from '@/utils/share'
  import Qs from 'qs'
  import {getStudyIndex,certificateList,uploadUserBrowse,getTelYzm,studyIsLogin,getReset} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo, getHotCity1,wxImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore,loadMore,scollLoadMore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        loadEnd: false, //数据加载结束则赋值为true
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        id:'',//活动id
        ruleShow:0,//活动规则弹窗 0：隐藏 1：显示
        ruleArticle:'',//活动规则html
        shareCardShow:0,//证书分享弹窗 0：隐藏 1：显示
        shopId:'',//景区活动ID
        loginState:0,//是否注册 0：未注册 1：已注册
        listShow:0,//证书排行弹窗 0：隐藏 1：显示
        loginShow:0,//注册弹窗 0：已注册隐藏 1：未注册显示
        certificateInfo:'',//证书信息
        shopsInfo:[],//景点列表
        shopsTotal:'',//景点总数
        page: 1,
        rows: 10,
        pageAlert: 1,
        rowsAlert: 10,
        loadText: "数据加载中",
        certificateListData:[],//研学证书列表
        listType:0,//研学证书列表排序方式 0：最新 1：得分
        studyName: '',
        studyTel: '',
        studyYzm: '',
        yzmTxt: '验证码',
        yzmSend: 0, //0：未发送 1：已发送
        count: 59, //倒计时
        timer: null, //计时器
        loadText1: '数据加载中', //弹窗列表提示
        isComplete:'',//是否完成研学活动
        score:'',//研学活动分数
        isRegister:'',//是否开启注册

        clientHeight:document.documentElement.clientHeight,
        showBtn: 1,  // 控制按钮盒子显示隐藏
        docmHeight: '0',  //默认屏幕高度
        showHeight:  '0',  //实时屏幕高度
        hidshow:true,  //显示或者隐藏footer,
        isResize:false, //默认屏幕高度是否已获取
        isDisable:false,//开始可以点击
      }
    },
    computed: {},
    created(){
      this.global.set_glabalClear()
      let self = this;
      this.$loading.show('数据加载中');
      this.id = this.$route.query.id;

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.userInfo = getStore("userInfo");
      this.initData(this.page);
      this.isLogin();
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll", function () {});
      document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
    },
    methods: {
      //初始化：获取研学首页数据
      async initData(page){
        this.loadEnd = false;
        let resStudyIndex = await getStudyIndex({
          TimeStamp: this.TimeStamp,
          id:this.id,//活动id
          openid:this.userInfo.openid,
          page:this.page,
          rows :this.rows
        });
        if(resStudyIndex.errcode == "00000"){
          this.$loading.hide();
          this.shopsTotal = resStudyIndex.data.shops.total;
          this.certificateInfo = resStudyIndex.data.data;
          this.isRegister = resStudyIndex.data.data.is_register;
          this.$route.meta.title = this.certificateInfo.name;
          let shopsInfo = resStudyIndex.data.shops.data;
          if (page >= Math.ceil(this.shopsTotal / this.rows)) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (shopsInfo.length > 0) {
            this.shopsInfo = [...this.shopsInfo, ...shopsInfo];
          } else {
            if (page == 1) {
              this.shopsInfo = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          let title = '金牌解说 | '+resStudyIndex.data.data.name;
          let desc = '金牌解说邀您参与文化研学，听解说！讲故事！弘扬历史文化！';
          let link = '/study?id='+this.id+'&TimeStamp'+this.TimeStamp +'&appKey=' + this.appKey;
          wxShareme(title,desc,"",link);
        }
      },

      //重新研学请求数据
      async resetFun(){
        this.$loading.show('数据加载中');
        let resReset = await getReset({
          TimeStamp: this.TimeStamp,
          openid:this.userInfo.openid,
          id:this.id,//活动id 默认10
        })
        if(resReset.errcode == "00000"){
          this.$loading.hide();
          this.shopsInfo = [];
          this.page = 1;
          this.initData(this.page);
        }
      } ,
      //重新研学点击事件
      resetFunBtn(){
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确定重新研学吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            self.resetFun();
          }
        }).catch(function(res){
          if(res == 'success') {
            self.resetFun();
          }
        })
      },

      async isLogin(){
        let loginBind = await studyIsLogin({
          TimeStamp: this.TimeStamp,
          openid:this.userInfo.openid,
          id:this.id
        });
        if(loginBind.errcode == "00000"){
          if(loginBind.data == true){
            this.loginState = 0
          }else{
            this.loginState = 1
          }
        }else{
          this.loginState = 1
        }
        console.log('注册状态'+this.loginState);
      },

      toDetail(e){
        let self = this;
        self.shopId = e.currentTarget.dataset.id;
        self.isComplete= e.currentTarget.dataset.iscomplete;
        self.score= e.currentTarget.dataset.score;
        self.$router.push({
          path: `/study-detail?${'id='+(self.shopId)+'&appKey='+(self.appKey)+'&TimeStamp='+(self.TimeStamp)}`
        });
      },
      isToDetail(e){
        let self = this;
        self.shopId = e.currentTarget.dataset.id;
        console.log(self.loginState);
        if(self.loginState == 0 && self.isRegister == 1){
          self.loginShow = 1;
        }else{
          self.$router.push({
            path: `/study-detail?${'id='+(self.shopId)+'&appKey='+(self.appKey)+'&TimeStamp='+(self.TimeStamp)}`
          });
        }
      },

      //登录注册弹窗
      loginSubmit(){
        let self = this;

        if ( (self.studyName == undefined || self.studyName == '' || self.studyName == null)) {
          self.$toast('请输入您的姓名')
          return
        }

        if (self.studyTel == undefined || self.studyTel == '' || self.studyTel == null) {
          self.$toast('请输入您的手机号码')
          return
        }
        if (!(/^1[34578]\d{9}$/.test(self.studyTel))) {
          self.$toast('手机号码格式不正确')
          return
        }
        if (self.studyYzm == undefined || self.studyYzm == '' || self.studyYzm == null) {
          self.$toast('请输入手机验证码')
          return
        }

        self.userInfo = getStore("userInfo");
        let url = "", obj = {};
        url = "plugin/bind.do";
        obj = {
          name:self.studyName,
          phone: self.studyTel,
          code: self.studyYzm,
          openid: self.userInfo.openid,
          id:self.id
        }

      if(self.isDisable == false){
//        console.log(self.isDisable );
        axios.post( getServer().admin + url, Qs.stringify(obj), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (data) {
          self.isDisable = true
//          console.log(self.isDisable );
          if(data.data.errcode == "00000"){
//            setStore("user", {"user":data.data.data},1);
            self.loginShow = 0
            self.$router.push({
              path: `/study-detail?${'id='+(self.shopId)+'&appKey='+(self.appKey)+'&TimeStamp='+(self.TimeStamp)}`
            });
          }else {
            self.$toast(data.data.errmsg);
          }
        })
      }else{
//        console.log('return'+self.isDisable );
        return
      }


      },

      //获取手机验证码
      async getYzm(){
        let self = this;
        if(self.yzmSend == 1){
          return;
        }
        if (self.studyTel == undefined || self.studyTel == '' || self.studyTel == null) {
          self.$toast('请输入您的手机号码')
          return
        }
        if (!(/^1[34578]\d{9}$/.test(self.studyTel))) {
          self.$toast('手机号码格式不正确')
          return
        }

        let res = await getTelYzm({
          TimeStamp: this.TimeStamp,
          phone: self.studyTel
        });
        if(res.errcode == "00000"){
          self.$toast('发送成功请稍等');
          self.yzmSend = 1;

          self.timer = setInterval(self.CountDown, 1000);
        }

      },
      CountDown(){
        this.yzmTxt = "重新发送(" + this.count + ")";
        if (this.count<= 0) {
          clearInterval(this.timer);
          this.yzmSend = 0;
          this.yzmTxt = "获取验证码";
        }
        this.count--;
      },

      //获取研学证书列表
      async certificateListSelNo(page){
        let resList = await certificateList({
          TimeStamp: this.TimeStamp,
          id:this.id,//活动id 默认10
          openid:this.userInfo.openid,
          type: this.listType,
          page:page,
          rows :this.rowsAlert
        });
        if(resList.errcode == "00000"){
          this.$loading.hide();
          let certificateListData = resList.data.data;
          if (page >= Math.ceil(resList.data.total / this.rowsAlert)) {
            this.loadText1 = '已经到底了'
          } else {
            this.loadText1 = '加载更多'
          }
          if (certificateListData.length > 0) {
            this.certificateListData = [...this.certificateListData, ...certificateListData];
          } else {
            if (page == 1) {
              this.certificateListData = [];
              this.loadText1 = '暂无数据'
            } else {
              this.loadText1 = '已经到底了'
            }
          }
        }else {
          this.$loading.hide();
          self.$toast(resList.data.errmsg);
        }
      },

      //获取研学证书列表方式
      certificateListSel(e){
        this.listType = e.currentTarget.dataset.type;
        this.pageAlert = 1;
        this.certificateListData = [];
        this.certificateListSelNo(this.pageAlert);
      },
      //研学排行弹窗显示
      listShowFun(){
        this.listShow = 1;
        this.certificateListSelNo(this.pageAlert);
      },

      //研学排行弹窗隐藏
      listClose(){
//        this.pageAlert = 1;
        this.certificateListData = [];
//        this.certificateListSelNo(this.pageAlert);
        this.listShow = 0;
      },



      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await
        uploadUserBrowse({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          loadMore(self,function(page){
            self.initData(page);
          });
        })
      },
      handleFun1: function (){
        let self = this;
        self.$nextTick(function() {
          scollLoadMore(self,'scollBox','loadTip',function(){
            self.pageAlert += 1;
            self.certificateListSelNo(self.pageAlert);
          });
        })
      },

      //图片预览
      seeImg(ind,imgs){
        let arr = [];
        arr.push(imgs);
        wxImgPreview(imgs,arr);
      },


  },

    watch:  {
      listShow(newVal,oldVal){
        if(newVal == 1){
          document.getElementById("scollBox").addEventListener("scroll",this.handleFun1)
        }else {
          document.getElementById("scollBox").removeEventListener("scroll",this.handleFun1)
        }
      },

      showHeight:function() {
        if(this.docmHeight > this.showHeight){
          this.showBtn=0
        }else{
          this.showBtn=1
        }
      }

    },
    components: {wxConfirm},
    mounted() {
      window.onresize = ()=>{
        return(()=>{
            if (!this.isResize) {                 
              //默认屏幕高度                 
            this.docmHeight = document.documentElement.clientHeight      
              this.isResize = true         
            }
            //实时屏幕高度
            this.showHeight = document.body.clientHeight
        })()
      }
    }

  }

</script>

<style scoped>
  .page{min-height:100vh;padding-bottom:1.07rem;background: -webkit-linear-gradient(top,#c4e88e,#65c473);background: linear-gradient(to bottom,#c4e88e,#65c473);}
  .banner{position:relative;width: 100%;height: 3.5rem;}
  .study_bg,.study_logo{position: absolute;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;}
  .bottom_tab{position: fixed;left: 0;bottom:0;width: 100%;height: 1.07rem;background: #fff;}
  .bottom_tab .flex{position:relative;width: 33.33%;height: 1.07rem;font: .26rem/1.07rem "Microsoft YaHei";color: #f56b5a;}
  .bottom_tab .flex:after{content:'';position: absolute;top:.34rem;bottom:.34rem;right:-.005rem;width: .01rem;background: #f56b5a;}
  .bottom_tab .flex:last-child:after{display: none;}
  .study_con{width: 100%;padding: 0 .38rem;margin-top: -.2rem;}
  .study_li{position:relative;display: block;width: 100%;height: 4.19rem;padding:.15rem .16rem .26rem;margin-bottom: .28rem;border-radius: .24rem;background: #fff;}
  .study_li:before,.study_li:after{content: '';position: absolute;bottom:-.28rem;width: .13rem;height: .28rem;background: #20523a;}
  .study_li:before{left:22.84%;}
  .study_li:after{right:22.84%;}
  .study_li:last-child:before,.study_li:last-child:after{display: none;}
  .study_li.card{height:auto;padding: .25rem .24rem .2rem;}
  .study_card{width: 100%;height: auto;border-radius: .08rem;}
  .card_btn{margin-top:.2rem;text-align: center;}
  .card_btn img{display: inline-block;width: auto;height: .89rem;margin: 0 .26rem;}
  .study_img{position:relative;width: 100%;height: 2.8rem;border-radius: .12rem;overflow: hidden;}
  .study_img img{width: 100%;height: 100%;object-fit: cover;border-radius: .12rem;}
  .score{position: absolute;width: 100%;height: 100%;top:0;left: 0;background: rgba(0,0,0,.54);}
  .score span{position: absolute;top:50%;left: 50%;padding: .12rem .24rem;font:bold .32rem/.42rem "Microsoft YaHei";letter-spacing:.02rem;color: #b15419;text-align: center;-webkit-transform: translate(-50%,-50%) rotate(-30deg);transform: translate(-50%,-50%) rotate(-30deg);}
  .score span img{position: absolute;top:0;left: 0;width: 100%;height: 100%;object-fit: cover;}
  .study_name{width:100%;height: .7rem;line-height: .7rem;margin-top:.28rem;font: bold .28rem/.7rem "Microsoft YaHei";color: #333;}
  .study_name .name{padding-left: .17rem;}
  .study_btn{width: 1.9rem;height: .7rem;margin-left:.2rem;font: bold .3rem/.7rem "Microsoft YaHei";color: #fff;text-align: center;border-radius: .35rem;background: -webkit-linear-gradient(top,#fea065,#f56b5a);background: linear-gradient(to bottom,#fea065,#f56b5a);}
  .complete .study_btn{background: #b0b0b0;}

  .alert_list,.alert_certificate,.alert_login,.alert_rule{position: fixed;top:0;left: 0;width: 100vw;height: 100vh;z-index: 3;}
  .mask{position: absolute;top:0;left: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,.69);}
  .close{position: absolute;top:.4rem;right: .34rem;width: .3rem;height: .3rem;z-index: 1;}

  /*证书分享弹窗*/
  .alert_certificate_box{position: absolute;left: .26rem;right: .26rem;bottom: -70%;padding:.42rem .36rem .36rem .36rem;border-radius: .18rem .18rem 0 0;background: #fff;}
  .certificate_tit{padding: 0 .7rem;font:bold .32rem "Microsoft YaHei";color: #0f0f0f;}
  .alert_certificate_img{width: 100%;height: auto;margin-top: .35rem;object-fit: cover;}
  .alert_certificate_tip{margin-top: .34rem;font-size: .24rem;color: #0f0f0f;}

  /*研学结业证书排行弹窗*/
  .list_box{position: absolute;top:1.2rem;left: .26rem;right: .26rem;bottom: 0;border-radius: .18rem .18rem 0 0;background: #fff;}
  .list_close{position: absolute;top:.38rem;right: .34rem;width: .3rem;height: .3rem;z-index: 1;}
  .list_top{margin-top: .43rem;margin-left:.26rem;font: bold .32rem "Microsoft YaHei";color: #0f0f0f;}
  .list_ul_box{ position: absolute;bottom: 0;top: 1.6rem;left:0;width:100%;overflow-y: scroll;padding-bottom: .4rem;margin-top: .5rem;}
  .list_ul{width: 100%;}
  .list_li{float: left;position:relative;width: 50%;height: 2.42rem;margin-top: .34rem;}
  .list_li:before{content:'';position: absolute;top:0;left:0;right:0;height: .02rem;background: #fbfbfb;}
  .list_li:nth-of-type(2n+1){padding: 0 .23rem 0 .26rem;}
  .list_li:nth-of-type(2n){padding: 0 .26rem 0.23rem ;}
  .list_li:nth-of-type(1),.list_li:nth-of-type(2){margin-top: 0;}
  .list_li_img{width: 100%;height: 2rem;object-fit: cover;}
  .list_li_info{margin-top: .08rem;font: .24rem "Microsoft YaHei";color: #333;}
  .list_score{width: 16%;text-align: right;}
  .list_tit{max-width: 73%;}
  .list_tab{width:100%;margin-top: .48rem;margin-left: .52rem;}
  .list_tab span{position:relative;display: inline-block;margin-right:.94rem;font: bold .26rem "Microsoft YaHei";color: #a4a3a3;}
  .list_tab span.curr{color: #040000;}
  .list_tab span.curr:after{content: '';position: absolute;left: -.07rem;right: -.07rem;bottom: -.1rem;height: .06rem;border-radius: .03rem;background: #f9ce17;}

  /*注册弹窗*/
  .login_box{position: absolute;left: .26rem;right: .26rem;bottom: -70%;padding:.83rem .26rem .3rem .26rem;border-radius: .18rem .18rem 0 0;background: #fff;}
  .alert_login{position: absolute;}
  .alert_login .login_close{top: .22rem;}
  .login_tit{font: bold .28rem "Microsoft YaHei";color: #0f0f0f;}
  .login_li{position:relative;width:100%;height:.87rem;margin-top: .23rem;padding-left:.9rem;border-radius: .12rem;background: #fafafa;}
  .login_li_icon{position: absolute;top:50%;left: .27rem;width:auto;height: .4rem;margin-top: -.2rem;}
  .login_li input{display: inline-block;width: 100%;height: 100%;padding:.2rem 0;font: .26rem "Microsoft YaHei";color: #666;background: #fafafa;}
  .login_li .box{position: absolute;left: 0;top: 0;width: 100%;height: 100%;}
  .login_li .flex{border-radius: .12rem;}
  .login_li .flex:first-child{ padding-left: .9rem;background: #fafafa;}
  .yzm_btn{width: 2.45rem;margin-left:.2rem;font: .26rem/.87rem "Microsoft YaHei";color: #fff;background: #f9b544;}
  .yzm_btn.disabled{ background: #cacaca; }
  .login_btn{width: 100%;height: .85rem;margin-top: .9rem;font: bold .3rem/.85rem "Microsoft YaHei";color: #fff;background: #f9b544;}

 .load-tip{color: #fff;}

 /*活动规则弹窗*/
  .rule_box{position: absolute;top:1.2rem;left: .26rem;right: .26rem;bottom: 0;padding: .8rem .28rem .4rem;border-radius: .18rem .18rem 0 0;background: #fff;}
  .rule_box .article{ width:100%;height:100%;overflow-y: auto;color: #333; }
  .rule_box .article *{ max-width: 100%; word-break: break-all; overflow: hidden; }
  .rule_tit{position: absolute;top:0;left: 0;width: 100%;    font: bold .32rem "Microsoft YaHei";color: #333;margin-top: .36rem;text-align: center;}
  /*弹窗动画*/
  .alert_certificate.curr,.alert_login.curr{display: block;}
  .alert_certificate.curr .alert_certificate_box,.alert_login.curr .login_box{-webkit-animation: slideUP .3s linear;animation: slideUP .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  @-webkit-keyframes slideUP{ from{bottom:-70%;}to{bottom:0%;}}
  @keyframes slideUP{ from{bottom:-70%;}to{bottom:0%;}}
</style>



// WEBPACK FOOTER //
// src/page/study/study.vue